import "shared/extensions/number";
import "./AddWaterIntakeModal.css";

import { Modal, ModalBody } from "shared/UI/Modal/Modal";

import { IconButton } from "UIPalette/IconButton/IconButton";
import { ReactComponent as MinusImage } from "shared/assets/Icons/minus.svg";
import { ReactComponent as PlusImage } from "shared/assets/Icons/plus.svg";
import Button from "shared/UI/Buttons/Button";
import { t } from "i18next";
import { useState } from "react";

enum MillilitresInA {
  Glass = 250,
  Pint = 568,
}

export interface AddWaterIntakeModalProps {
  millilitres: number;
  onClose: Function;
  onSave: Function;
}

export const AddWaterIntakeModal = (props: AddWaterIntakeModalProps) => {
  const [millilitres, setMillilitres] = useState(props.millilitres);

  const displayedMillilitres = t("wellbeing.trackers.water.addData.units.millilitres", { count: millilitres });
  const glasses = t("wellbeing.trackers.water.addData.units.glasses", { count: (millilitres / MillilitresInA.Glass).toDecimalPlaces(2) });
  const pints = t("wellbeing.trackers.water.addData.units.pints", { count: (millilitres / MillilitresInA.Pint).toDecimalPlaces(2) });

  function decrement() {
    if (millilitres > 0) {
      setMillilitres(millilitres - MillilitresInA.Glass);
    }
  }

  function increment() {
    setMillilitres(millilitres + MillilitresInA.Glass);
  }

  return (
    <Modal width="xs" close={() => props.onClose()}>
      <ModalBody>
        <div className="flex flex-col gap-4">
          <h2 className="pb-0">{t("wellbeing.trackers.water.addData.heading")}</h2>
          <p role="paragraph">{t("wellbeing.trackers.water.addData.description")}</p>
          <div className="flex flex-row">
            <IconButton
              ariaLabel={t("wellbeing.trackers.buttons.aria-minus")}
              icon={<MinusImage width="24" height="24" />}
              active={millilitres > 0}
              fgColour="text-white"
              bgColour="bg-navy-blue hover:bg-navy-blue-light"
              handleClick={decrement}
              hasDropShadow={false}
            />
            <div className="flex flex-col flex-grow place-items-center">
              <span role="note" aria-label={t("wellbeing.trackers.water.addData.aria.glasses")}>
                {glasses}
              </span>
              <div className="flex-row">
                <span role="note" aria-label={t("wellbeing.trackers.water.addData.aria.millilitres")}>
                  {displayedMillilitres}
                </span>
                <span> / </span>
                <span role="note" aria-label={t("wellbeing.trackers.water.addData.aria.pints")}>
                  {pints}
                </span>
              </div>
            </div>
            <IconButton
              ariaLabel={t("wellbeing.trackers.buttons.aria-plus")}
              icon={<PlusImage width="24" height="24" />}
              active={true}
              fgColour="text-white"
              bgColour="bg-navy-blue hover:bg-navy-blue-light"
              handleClick={increment}
              hasDropShadow={false}
            />
          </div>
          <Button text={t("wellbeing.trackers.buttons.save")} onClick={() => props.onSave(millilitres)} />
          <Button variant="text" text={t("wellbeing.trackers.buttons.back")} onClick={() => props.onClose()} />
        </div>
      </ModalBody>
    </Modal>
  );
};
